import { useState, useEffect } from "react";
import axios from "axios";
import useAuth from "../../auth/hooks/useAuth";

const useRatingQuestions = params => {
  const [questions, setQuestions] = useState();
  const [status, setStatus] = useState();
  const { state: authState } = useAuth();

  useEffect(() => {
    try {
      (async () => {
        setStatus("LOADING");

        const response = await axios({
          method: "get",
          url: `${process.env.REACT_APP_API}/lite/intervention/questions`,
          params,
          headers: {
            Authorization: `Bearer ${authState.access_token}`
          }
        });
        setQuestions(response.data);
        console.log(response.data)
        setStatus("OK");
      })();
    } catch (e) {
      setStatus("ERROR");
      console.log("error")
    }
  }, []);

    return {
      questions,
      status
    };
};

export default useRatingQuestions;
